import { __awaiter } from "tslib";
import Vue from 'vue';
import { mapGetters } from 'vuex';
export default Vue.extend({
    props: {
        slotData: {
            type: Object,
            required: true
        }
    },
    name: 'walletSecretConfirmPopupChunk',
    data: () => ({
        step: 1,
        hasWhiteListSecret: true,
        form: {
            fields: {
                secretCode: {
                    valid: false,
                    value: '',
                    type: 'password',
                    rules: [
                        (v) => Boolean(v.length) || 'Поле обязательно'
                    ],
                    responseErrors: []
                }
            }
        }
    }),
    computed: Object.assign({}, mapGetters('user', ['getUserData'])),
    watch: {
        'form.fields.secretCode.value'() {
            this.$store.commit('popupModule/setSlotData', { responseErrors: [] });
        }
    },
    created() {
        this.checkWhitelistSecret();
    },
    methods: {
        checkWhitelistSecret() {
            return __awaiter(this, void 0, void 0, function* () {
                const response = yield this.services.mainService.checkWhitelistSecret(null);
                this.hasWhiteListSecret = response.data.walletSecret;
            });
        },
        toggleSecretAppear() {
            const vm = this;
            vm.form.fields.secretCode.type = vm.form.fields.secretCode.type === 'password' ? 'text' : 'password';
        }
    }
});
